import Vue from 'vue'
import App from './App.vue'
import routes from './js/router.js';
import VueRouter from 'vue-router'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'es6-promise/auto'
import axios from 'axios'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import auth from './js/auth'

import jquery from'jquery'
window.$=window.jquery=jquery
import "popper.js";
import "bootstrap";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'



import './CustomStyles/custom.css';
import './CustomStyles/w3.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "../src/assets/css/styles.css"

Vue.component("v-select", vSelect);



// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueSidebarMenu)


Vue.router = routes
Vue.use(VueRouter)

Vue.config.productionTip = false
// 

// Set Vue authentication
// axios.defaults.baseURL = 'http://localhost:52804/api';
//live anaj
// c

//hina anaj live 
// axios.defaults.baseURL = 'https://anaj2.itrooscloud.net/api';
//hina anaj demo
axios.defaults.baseURL = 'https://app.anaj.pk/api';


// axios.defaults.baseURL = 'http://68.183.182.247:32769/api'
axios.defaults.headers.common['Content-Type']= 'application/json';
Vue.use(VueAxios, axios)
Vue.use(VueAuth, auth)
Vue.use(require('vue-moment'));
new Vue({
  render: h => h(App),
  router:routes,
  watch: {
    $route: function(to, from) {
     console.log(to);
     console.log(from);
    }
  }
}).$mount('#app')
